import { render } from "./DangerAlert.vue?vue&type=template&id=4ce9ca0c&scoped=true"
import script from "./DangerAlert.vue?vue&type=script&lang=js"
export * from "./DangerAlert.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce9ca0c"]])

export default __exports__